import React from 'react';
import { Portal } from './Portal';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import './Modal.css';

export const Modal = ({ children, toggle, isActive }) => {
  return (
    <Portal>
      {isActive && (
        <div className='wrapper'>
          <div className='window'>
            <div style={{ position: 'sticky', top: '0', right: '0' }}>
              <button
                onClick={toggle}
                className='closeBtn'
                style={{ cursor: 'pointer' }}
              >
                <HighlightOffIcon />
              </button>
            </div>
            <div className='text'>{children}</div>
          </div>
        </div>
      )}
    </Portal>
  );
};
